export enum VoteValueType {
  Yes = 'Yes',
  No = 'No',
  Abstain = 'Abstain',
}

export enum VotingRuleType {
  SimpleMajority = 'SimpleMajority',
  OneThirdMajority = 'OneThirdMajority',
  TwoThirdsMajority = 'TwoThirdsMajority',
}
